import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row g-4" }
const _hoisted_2 = { class: "col-lg-4 col-md-6" }
const _hoisted_3 = { class: "card border-0 shadow-sm rounded-3 h-100" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "list-unstyled mb-0" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "fw-semibold" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "fw-semibold" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "col-lg-8 col-md-6" }
const _hoisted_12 = { class: "card border-0 shadow-sm rounded-3 h-100" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row g-3" }
const _hoisted_15 = { class: "col-sm-6" }
const _hoisted_16 = { class: "fw-semibold" }
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = { class: "fw-semibold" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "fw-semibold" }
const _hoisted_23 = { class: "col-12" }
const _hoisted_24 = { class: "fw-semibold" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "fw-semibold" }
const _hoisted_27 = { class: "col-sm-6" }
const _hoisted_28 = { class: "fw-semibold" }
const _hoisted_29 = { class: "col-sm-6" }
const _hoisted_30 = { class: "fw-bold text-success" }
const _hoisted_31 = {
  key: 0,
  class: "col-12"
}
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = { class: "card border-0 shadow-sm rounded-3" }
const _hoisted_34 = { class: "card-body p-0" }
const _hoisted_35 = { class: "table-responsive" }
const _hoisted_36 = { class: "table align-middle mb-0" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "fw-semibold" }
const _hoisted_39 = { class: "text-muted" }
const _hoisted_40 = { class: "d-block" }
const _hoisted_41 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header bg-primary text-white d-flex align-items-center" }, [
          _createElementVNode("i", { class: "bi bi-person-circle fs-4 me-2" }),
          _createElementVNode("h5", { class: "mb-0 fs-16 fw-semibold" }, "Informations Client")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Magasin", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.colisRow?.client?.store ?? _ctx.colisRow.customer_name), 1)
            ]),
            _createElementVNode("li", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Client", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.colisRow?.client?.name), 1)
            ]),
            _createElementVNode("li", null, [
              _cache[4] || (_cache[4] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Téléphone", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", {
                href: `tel:${_ctx.colisRow?.client?.phone}`,
                class: "text-decoration-none text-dark fw-semibold"
              }, _toDisplayString(_ctx.colisRow?.client?.phone), 9, _hoisted_10)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "card-header bg-success text-white d-flex align-items-center" }, [
          _createElementVNode("i", { class: "bi bi-box-seam fs-4 me-2" }),
          _createElementVNode("h5", { class: "mb-0 fs-16 fw-semibold" }, "Informations Colis")
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Code d'envoi", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.colisRow.code), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[9] || (_cache[9] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Destinataire", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.colisRow.receiver), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[11] || (_cache[11] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Téléphone", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("a", {
                href: `tel:${_ctx.colisRow.phone}`,
                class: "text-decoration-none text-dark fw-semibold"
              }, _toDisplayString(_ctx.colisRow.phone), 9, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[13] || (_cache[13] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Ville", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.colisRow.city_name), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[15] || (_cache[15] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Adresse", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.colisRow.adresse), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[17] || (_cache[17] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Commentaire", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.colisRow.note), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[19] || (_cache[19] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Nature Produit", -1)),
              _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.colisRow.product_nature), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[21] || (_cache[21] = _createElementVNode("small", { class: "text-muted text-uppercase" }, "Crbt", -1)),
              _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.colisRow.price) + " Dhs", 1)
            ]),
            (_ctx.colisRow.from_stock === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[23] || (_cache[23] = [
                  _createElementVNode("span", { class: "badge bg-warning text-dark" }, [
                    _createElementVNode("i", { class: "bi bi-box" }),
                    _createTextVNode(" Colis de Stock ")
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "card-header bg-primary text-white d-flex align-items-center" }, [
          _createElementVNode("i", { class: "bi bi-bag-check fs-4 me-2" }),
          _createElementVNode("h5", { class: "mb-0 fs-16 fw-semibold" }, "Produits")
        ], -1)),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("table", _hoisted_36, [
              _cache[27] || (_cache[27] = _createElementVNode("thead", { class: "bg-light" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th"),
                  _createElementVNode("th", null, "Produit"),
                  _createElementVNode("th", null, "Informations")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colisRow.products, (product, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "border-bottom"
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("img", {
                        src: 
                        product.product_pic ||
                        require('@/assets/images/NoImage.png')
                      ,
                        width: "60",
                        height: "60",
                        class: "rounded-2 border"
                      }, null, 8, _hoisted_37)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_38, _toDisplayString(product.product_name), 1),
                      _createElementVNode("small", _hoisted_39, _toDisplayString(product.variant_name) + " - " + _toDisplayString(product.variant_ref), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("small", _hoisted_40, [
                        _cache[25] || (_cache[25] = _createElementVNode("b", null, "Quantité :", -1)),
                        _createTextVNode(" " + _toDisplayString(product.qnty), 1)
                      ]),
                      _createElementVNode("small", _hoisted_41, [
                        _cache[26] || (_cache[26] = _createElementVNode("b", null, "Date :", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.getDate(product.created_at)), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}